import features from "./geo-map-definition.json";

export interface ICasesMapInputs {
  data: any;
  domain: number[];
  features: any;
}

export const getCasesMapOptions = (
  gridRef: any,
  lookup_key: string
): ICasesMapInputs | null => {
  const gridApi = gridRef?.current?.api;

  if (!gridApi) {
    return null;
  }

  const featuresIn: any = features.features;

  const dataIn = getCaseMapData(gridApi, lookup_key);

  const casesMapInputs: ICasesMapInputs = {
    features: featuresIn,
    ...dataIn,
  };

  return casesMapInputs;
};

export const getCaseMapData = (gridApi: any, lookup_key: string) => {
  // [{
  //   "id": "AFG",
  //   "value": 170788
  // }]

  const countryCounts = {};

  // iterate only nodes that pass the filter
  gridApi.forEachNodeAfterFilter((rowNode, index) => {
    if (rowNode.data && rowNode.data.hasOwnProperty(lookup_key)) {
      const rowCountry = rowNode.data[lookup_key].trim();

      if (countryCounts[rowCountry]) {
        countryCounts[rowCountry] += 1;
      } else {
        countryCounts[rowCountry] = 1;
      }
    }
  });

  let largestCount = 10;

  const arrayOfCountryCounts = Object.keys(countryCounts).map((country) => {
    const count = countryCounts[country];

    if (count > largestCount) {
      largestCount = count;
    }

    return {
      id: country,
      value: count,
    };
  });

  return {
    data: arrayOfCountryCounts,
    domain: [0, Math.ceil(largestCount / 10) * 10],
  };
};
